import "./testimonials.scss";

export default function Testimonials() {
  const data = [
    {
      id: 1,
      name: "Brandon",
      // title: "Startup Founder",
      img:
        "https://images.pexels.com/photos/1680172/pexels-photo-1680172.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
      // icon: "assets/twitter.png",
      desc:
        "Always a Pleasure to work with Damola. Excellent communication. Pays attention to every detail",
    },
    {
      id: 2,
      name: "Sharon Delka",
      // title: "Freelancer",
      img:
        "https://images.pexels.com/photos/428321/pexels-photo-428321.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
      // icon: "assets/youtube.png",
      desc:
        "He was very professional and patient throughout the entire process and the project was completed ahead of schedule. Highly recommended!!",
      featured: true,
    },
    {
      id: 3,
      name: "Mark Evans",
      // title: "CEO of ALBI",
      img:
        "https://images.pexels.com/photos/3863793/pexels-photo-3863793.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
      // icon: "assets/linkedin.png",
      desc:
        "Damola is not only interested in working on a project, he is always willing to understand the clients need and then aligns it with the business goal",
    },
  ];
  return (
    <div className="testimonials" id="testimonials">
      <h1>Testimonials</h1>
      <div className="container">
        {data.map((d) => (
          <div className={d.featured ? "card featured" : "card"}>
            <div className="top">
              <img src="assets/right-arrow.png" className="left" alt="" />
              <img
                className="user"
                src={d.img}
                alt=""
              />
              <img className="right" src={d.icon} alt="" />
            </div>
            <div className="center">
              {d.desc}
            </div>
            <div className="bottom">
              <h3>{d.name}</h3>
              <h4>{d.title}</h4>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}